import ReactOnRails from "react-on-rails/client";
// TODO: Needs to update the page containers once we have them in mobius
import { QuestionnairePage } from "@simplybusiness/mobius-journey";
import DevTools from "../components/DevTools";
import Autofill from "../components/Autofill";
import SkipToQcp from "../components/SkipToQcp";
import ViewTraces from "../components/ViewTraces";

ReactOnRails.register({
  QuestionnairePage,
  DevTools,
  Autofill,
  SkipToQcp,
  ViewTraces,
});
